import React, { memo } from 'react';
import ResetButton from '../buttons/ResetButton';
import BackgroundTypeControls from './BackgroundTypeControls';
import BackgroundColor from './BackgroundColor';
import Stroke from './Stroke';
import FillColor from './FillColor';
import Rotation from './Rotation';
import Scale from './Scale';
import Filters from './Filters';

/**
 * This form is used to update SVG preview properties.
 */
const Form = () => {

    return (
        <div className="rounded p-4">
             <div className="grid lg:grid-cols-2 gap-6 items-center">

                 <BackgroundTypeControls />
                 <BackgroundColor />
                 <Stroke />
                 <FillColor />
                 <Rotation />
                 <Scale />
                 <Filters />

                 <div>
                    <ResetButton />
                 </div>

            </div>

        </div>
    )
};

export default memo(Form);